import { connect } from 'react-redux';
import ModalParametersForm from './ModalParametersForm';
import { addParameters } from '../../../redux/actions';
import {
  spinToWinLimitSelector,
  newSpinToWinSelector,
} from '../../../redux/selectors/featureActionsSelector';

const mapStateToProps = state => ({
  spinToWinLimit: spinToWinLimitSelector(state),
  newSpinToWinOptions: newSpinToWinSelector(state),
});

const mapDispatchToProps = {
  addParameters,
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  formType: 'spinToWin',
  initialValues: {
    ...stateProps.newSpinToWinOptions,
    dailyLimit: stateProps.newSpinToWinOptions.dailyLimit || stateProps.spinToWinLimit,
  },
  onSubmit: (values) => {
    dispatchProps.addParameters({
      newSpinToWinOptions: {
        ...stateProps.newSpinToWinOptions,
        ...values,
      },
    });
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(ModalParametersForm);



// WEBPACK FOOTER //
// ./src/js/common/components/ModalParametersForm/SpinToWinLimitForm.js